import { useMutation } from'@tanstack/react-query';
import { useSmartQuery, useSmartMutation } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { createReconnectRequest, getTimeSlotChoices, createReconnectionWithPayment, createBulkReconnectRequest, searchMasterConsumers } from'./api';
import { ReconnectRequestPayload } from'./types';
import { toast } from '@shared/hooks/use-toast';
import { queryClient } from '@shared/api/queries/queryClient';

export const useCreateReconnect = () => {
  return useSmartMutation(
    (data: ReconnectRequestPayload) => createReconnectRequest(data),
    {
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["cx", "consumerRequests", "list"] });
        }
    }
  );
};

export const useTimeSlotChoices = () => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.disconnection.timeSlotChoices(),
    () => getTimeSlotChoices(),
  );
};

export const useCreateReconnectionWithPayment = () => {
  return useSmartMutation(
    (data: any) => createReconnectionWithPayment(data),
    {
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["cx", "consumerRequests", "list"] });
        }
    }
  );
};

export const useCreateBulkReconnectRequest = () => {
  return useSmartMutation(
    (data: any) => createBulkReconnectRequest(data),
    {
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["cx", "consumerRequests", "list"] });
        }
    }
  );
};

export const useSearchMasterConsumers = (params: { remoteUtilityId: number; searchData: string }) => {
  return useSmartQuery(
    ['cx', 'consumer-search', params.remoteUtilityId, params.searchData],
    () => searchMasterConsumers(params),
    {
      enabled: false,
    }
  );
};
